import { render, staticRenderFns } from "./ChangePostPackagePostCode.vue?vue&type=template&id=99352340&scoped=true"
import script from "./ChangePostPackagePostCode.vue?vue&type=script&lang=js"
export * from "./ChangePostPackagePostCode.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99352340",
  null
  
)

export default component.exports